import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import AppInput from '../../../../common/AppInput';
import { FIELDS_PAGE_ERROR } from './validation/fields';
import { usePageErrorStyles } from './styles';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { onData, mobile, state, motiveId } = props;
  const classes = usePageErrorStyles({ mobile });

  const handleOnChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      <Box>
        {FIELDS_PAGE_ERROR.map((field, index) => (
          <AppInput
            key={index}
            onChange={handleOnChange}
            onBlur={() => {}}
            onClick={() => {}}
            disabled={state[field.name]?.disabled || false}
            name={field.name}
            error={state[field.name]?.error || false}
            type={state[field.name]?.type || ''}
            label={state[field.name]?.label || ''}
            required={state[field.name]?.required || false}
            inputAdornment={state[field.name]?.inputAdornment || ''}
            success={state[field.name]?.success || false}
            helperText={state[field.name]?.helper || ''}
            errorMessage={state[field.name]?.message || ''}
            multiline={field?.multiline || false}
            rows={field?.rows || 1}
          />
        ))}
      </Box>
    </React.Fragment>
  );
};

Form.propTypes = {
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  state: PropTypes.object,
  motiveId: PropTypes.string,
};

export default Form;
